import Respondents from './RespondentsContainer';
import ImportFileResDetail from './Import/component/ImportFileDetail/ImportFileResDetail';
import RespondentImportContainer from './Import/RespondentImportContainer';
import NewRespondentImport from './Import/NewRespondentImport';
import RespondentDetailContainer from './detail/RespondentDetailContainer';
import NewRespondentContainer from './new/NewRespondentContainer';

const respondentRoutes = [
  {
    exact: true,
    path: '/accounts/:aid/respondents/new',
    component: NewRespondentContainer,
  },
  {
    exact: true,
    path: '/accounts/:aid/respondents/imports/new',
    component: NewRespondentImport,
  },
  {
    path: '/accounts/:aid/respondents/imports/:importFileId',
    component: ImportFileResDetail,
  },
  {
    exact: true,
    path: '/accounts/:aid/respondents/imports',
    component: RespondentImportContainer,
  },
  {
    path: '/accounts/:aid/respondents/:respondentId',
    component: RespondentDetailContainer,
  },
  {
    path: '/accounts/:aid/respondents/',
    component: Respondents,
  },
];

export default respondentRoutes;
